import { useState } from "react";
import {
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Table,
  TableHead,
  Box,
  IconButton,
  Typography,
  Menu,
  MenuItem,
} from "@mui/material";
import StoreIcon from "../common/StoreIcon";
import { fCurrency } from "src/utils/formatNumber";
import Iconify from "../iconify";

export default function CoinBundleItemsTable(props) {
  console.log("CoinBundleItemsTable props:", props);
  const { onEdit, onDelete, isViewer } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleEdit = () => {
    if (onEdit && selectedRow) onEdit(selectedRow);
    handleMenuClose();
  };

  const handleDelete = () => {
    if (onDelete && selectedRow) onDelete(selectedRow);
    handleMenuClose();
  };
  return (
    <Box sx={{ p: 0 }}>
      <Typography variant="h6" gutterBottom sx={{ mt: 2, mb: 2 }}>
        Coins Bundle
      </Typography>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Coin Amount</TableCell>
              <TableCell>Cost</TableCell>
              <TableCell>Revenue</TableCell>
              <TableCell>Unit Sale</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props?.rows
              ?.filter((row) => row.amount !== -1)
              .sort((a, b) => a.amount - b.amount)
              .map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell component="th" scope="row">
                    <StoreIcon store={row.store} />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.description}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.amount}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.price}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {fCurrency(Math.round(row.totalPrice / 100))}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.totalUnits}
                  </TableCell>
                  {!isViewer && (
                    <TableCell align="right">
                      <IconButton onClick={(e) => handleMenuOpen(e, row)}>
                        <Iconify icon="eva:more-vertical-fill" />
                      </IconButton>
                    </TableCell>
                  )}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Typography variant="h6" gutterBottom sx={{ mt: 2, mb: 2 }}>
        Coins Spin
      </Typography>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Cost</TableCell>
              <TableCell>Revenue</TableCell>
              <TableCell>Unit Sales</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props?.rows
              ?.filter((row) => row.amount === -1)
              .map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell component="th" scope="row">
                    <StoreIcon store={row.store} />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.description}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.price}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {fCurrency(Math.round(row.totalPrice / 100) * 100)}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.totalUnits}
                  </TableCell>
                  {!isViewer && (
                    <TableCell align="right">
                      <IconButton onClick={(e) => handleMenuOpen(e, row)}>
                        <Iconify icon="eva:more-vertical-fill" />
                      </IconButton>
                    </TableCell>
                  )}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handleEdit}>
          <Iconify icon="eva:edit-outline" style={{ marginRight: 8 }} />
          Edit
        </MenuItem>
        <MenuItem onClick={handleDelete}>
          <Iconify icon="eva:trash-outline" style={{ marginRight: 8 }} />
          Delete
        </MenuItem>
      </Menu>
    </Box>
  );
}
